<template>
  <div class="OperatingSystemSearch">
    <!-- <Row> -->
    <!-- <Col span="4"> -->
    <add-operating-system></add-operating-system>
    <!-- </Col> -->
    <!-- </Row> -->
  </div>
</template>
<script>
import AddOperatingSystem from "../operating_system/AddOperatingSystem";
export default {
  name: "OperatingSystemSearch",
  components: {
    AddOperatingSystem
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
.OperatingSystemSearch {
  background-color: #fff;
  height: 51px;
  padding: 4px 0px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/operating_system/OperatingSystemSearch.vue